module.exports = __webpack_public_path__ + "videos/color_cn.70c18ae.mp4";